
import wx from 'weixin-js-sdk'
import { getConfig } from '@/api/wx.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getProductDetail, sumbitOrder } from '@/api/youzheng.js'
import { getAddressDefault, getintegral } from '@/api/user.js'
import { getSelfAddress } from '@/api/sys.js'
import { getOrderNum, getWechatPay, timePanduan, updateZF } from '@/api/mall.js'
import Storage from '@/storage'
import errorImg from '@/assets/mall/img-error.png'
import config from '@/config/index'
import addressedit from '@/views/address-select'
export default {
name: 'sumbitorder',
directives: {
TransferDom
},
data () {
return {
id: this.$route.params.id,
goodsObj: {},
baseUrl: config.baseUrl,
errorImg: errorImg,
score: 0,
num: 1,
addressObj: {},
openid: Storage.get('openId'),
owner_type: config.owner_type,
integral: '',
deliveryList: [{
name: '自提',
value: '1'
}, {
name: '快递',
value: '2'
}],
delivery: ['2'],
selfAddress: '',
maxnum: 0,
isColor: ['#db2111', '#ec653c'],
openAddress: false,
message: '',
ordNum: '',
totalPrice: '',
paySignObj: {}
}
},
components: {
Cell,
Group,
Flexbox,
FlexboxItem,
XNumber,
XTextarea,
XButton,
PopupRadio,
PopupPicker,
Popup,
addressedit
},
created () {
this.getOrder()
this.getAddress()
this.getDetail()
this.getintegralTotal()
this.wxconfig()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
activated () {
if (this.$store.state.user.address.ID !== '') {
this.openAddress = true

}
},
watch: {
num (val) {
if (val < 1 && val !== '') {
this.$vux.toast.text('受不了了，宝贝不能再减少了哦', 'middle')
} else if (this.goodsObj.LIMITNUM == 0 && val >= this.goodsObj.AMOUNT) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.AMOUNT + '件', 'middle')
} else if (this.goodsObj.LIMITNUM >= this.goodsObj.AMOUNT && this.goodsObj.LIMITNUM != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.AMOUNT + '件', 'middle')
} else if (this.goodsObj.LIMITNUM < this.goodsObj.AMOUNT && this.goodsObj.LIMITNUM != 0) {
this.$vux.toast.text('该商品最多只能购买' + this.goodsObj.LIMITNUM + '件', 'middle')
}
this.score = this.goodsObj.CREDIT * val
this.totalPrice = this.goodsObj.saleprice * val
},
delivery: {
handler (val) {
if (val == 1) {
this.getlift()
}
},
deep: true
}
},
methods: {

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['getBrandWCPayRequest'] 
})
})
},
getintegralTotal () {
getintegral({
accountid: this.accountid,
userid: this.userid,
owner_type: this.owner_type
}).then(res => {
this.integral = res.returnValue.allnow
})
},
getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue != '') {
this.addressObj = res.returnValue
}
})
},
getDetail () {
getProductDetail({
productid: this.id
}).then(res => {
this.goodsObj = res.returnValue
this.score = this.goodsObj.CREDIT * this.num
this.totalPrice = this.goodsObj.saleprice * this.num
if (this.goodsObj.LIMITNUM !== 0) {
if (this.goodsObj.AMOUNT <= this.goodsObj.LIMITNUM) {
this.maxnum = this.goodsObj.AMOUNT
} else {
this.maxnum = this.goodsObj.LIMITNUM
}
} else {
this.maxnum = this.goodsObj.AMOUNT
}
})
},
onImgError ($event) {
$event.target.src = this.errorImg
},

getOrder () {
getOrderNum().then(res => {
this.ordNum = res.obj
})
},
sumbit () {
if (JSON.stringify(this.addressObj) !== '{}') {
if (this.num > 0) {
if (this.goodsObj.ISSHOW == 2) {
timePanduan({ id: this.id }).then(res => {
if (res.obj) {
this.getwxPay()
} else {
this.$vux.toast.text('当前商品秒杀未在进行中', 'middle')
}
})
} else {
this.getwxPay()
}
} else {
this.$vux.toast.text('请选择兑换数量', 'middle')
}
} else {
this.$vux.toast.text('请选择收货地址', 'middle')
}
},

getwxPay () {
getWechatPay({
productid: this.id,
userid: this.userid,
total_fee: this.totalPrice,
out_trade_no: this.ordNum,
body: '123'
}).then(res => {
if (res.obj !== '') {
this.paySignObj = JSON.parse(res.obj)
console.log(this.paySignObj)
this.onBridgeReady(this.paySignObj)
}
})
},
onBridgeReady (data) {
WeixinJSBridge.invoke(
'getBrandWCPayRequest',
{
'appId': data.appId, // 公众号ID，由商户传入
'timeStamp': data.timeStamp, // 时间戳，自1970年以来的秒数
'nonceStr': data.nonceStr, // 随机串
'package': data.package,
'signType': data.signType, // 微信签名方式：
'paySign': data.paySign // 微信签名
},
(res) => {
if (res.err_msg === 'get_brand_wcpay_request:ok') {







updateZF({
orderpayid: this.ordNum
})
this.getCredit()
} else {
this.$vux.alert.show({
title: '提示',
content: '支付失败，请重新支付！'
})
}
})
},


getCredit () {
sumbitOrder({
productid: this.id,
accountid: this.accountid,
addressid: this.addressObj.ID,
ordercredit: this.score,
ordertype: 1,
insertsource: 1,
productnum: this.num,
userid: this.userid,
ispickbyself: parseInt(this.delivery[0]),
note: this.message
}).then(res => {
var that = this
this.integral = this.integral - this.score
this.$vux.alert.show({
title: '兑换成功！',
content: '已支付' + this.totalPrice + '元' + '已扣除' + this.score + '积分，当前您剩余<span style="color:red">' + this.integral + '</span>积分',
buttonText: '返回我的订单',
onShow () { },
onHide () {
that.$router.push({ name: 'mall2Orderlist' })
}
})
})
},

getlift () {
getSelfAddress().then(res => {
if (res.obj && res.obj.length > 0) {
this.selfAddress = res.obj[1].value
}
})
},
openPopup () {
this.openAddress = true

},
changeAddress (isdisplay) {
if (isdisplay === 'false') {
this.openAddress = false
this.addressObj = this.$store.state.user.address
}
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
if (from.name === 'addressAdd') {
vm.openAddress = true
}
})
}
}
